import store from '@/store';

export async function addRequest(config) {
    return await store.dispatch('requests/add', config);
}

export default addRequest;
